// extracted by mini-css-extract-plugin
export var aiStarIcon = "_bb-4";
export var closeButton = "_bb-6";
export var dismissButton = "_bb-3";
export var editImageWithAiContainer = "_bb-8";
export var imageUploadWrapper = "_bb-7";
export var misspelledWord = "_bb-5";
export var spellCheckContainer = "_bb-2";
export var spin = "_bb-1";
export var spinning = "_bb-0";